import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/referralCampaign.ts
const unauthorizedError = { UNAUTHORIZED: {
	status: 401,
	message: "Authentication required"
} };
const inviterEligibilitySchema = z.object({
	eligible: z.boolean(),
	emailVerified: z.boolean(),
	hasGenerated: z.boolean()
});
const campaignSchema = z.object({
	campaignId: z.string(),
	enabled: z.boolean(),
	startDate: z.string(),
	endDate: z.string(),
	inviterRewardCredits: z.number(),
	inviteeRewardCredits: z.number()
}).nullable();
const summaryOutputSchema = z.object({
	campaign: campaignSchema,
	inviterEligibility: inviterEligibilitySchema,
	totalInvited: z.number(),
	qualifiedCount: z.number(),
	distributedCount: z.number()
});
const inviteeStatusSchema = z.object({
	emailVerified: z.boolean(),
	hasExternalLogin: z.boolean(),
	claimDays: z.number(),
	hasGenerated: z.boolean(),
	qualified: z.boolean()
});
const entrySchema = z.object({
	id: z.string(),
	inviteeId: z.string(),
	inviteeDisplayName: z.string(),
	inviteeUsername: z.string(),
	inviteeAvatarUrl: z.string().nullable(),
	inviteeStatus: inviteeStatusSchema,
	inviterRewardStatus: z.enum([
		"PENDING",
		"QUALIFIED",
		"DISTRIBUTED",
		"SKIPPED"
	]),
	inviteeRewardStatus: z.enum([
		"PENDING",
		"QUALIFIED",
		"DISTRIBUTED",
		"SKIPPED"
	]),
	inviterEstimatedRewardAt: z.string().nullable(),
	inviteeEstimatedRewardAt: z.string().nullable(),
	createdAt: z.string()
});
const entriesOutputSchema = z.object({
	entries: z.array(entrySchema),
	nextCursor: z.string().nullable(),
	totalCount: z.number()
});
const referralCampaignContract = oc.prefix("/referral-campaign").tag("ReferralCampaign").router({
	summary: oc.route({
		summary: "Get campaign summary",
		description: "Returns campaign config, inviter eligibility, and invitation counts.",
		method: "GET",
		path: "/summary"
	}).output(summaryOutputSchema).errors(unauthorizedError),
	entries: oc.route({
		summary: "List invitation entries",
		description: "Returns paginated invitation records for the current user as inviter.",
		method: "GET",
		path: "/entries"
	}).input(z.object({
		cursor: z.string().regex(/^\d+$/).optional(),
		limit: z.coerce.number().int().min(1).max(50).optional()
	})).output(entriesOutputSchema).errors(unauthorizedError),
	inviteeStatus: oc.route({
		summary: "Get invitee status",
		description: "Returns the current user's qualification status as an invitee, or null.",
		method: "GET",
		path: "/invitee-status"
	}).output(entrySchema.nullable()).errors(unauthorizedError)
});
//#endregion
export { referralCampaignContract };
